class FormField {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-formfield',
            filledClassname: 'is--filled',
            focusedClassname: 'is--focused',
            errorClassname: 'form-field--error'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$formField = $element;

        this.initialize();
    }

    initialize () {
        this.initField(this.$formField);
    }

    initField ($element) {
        this.checkField($element);

        const $field = $element.querySelector('select, input, textarea');

        if ($field) {
            $field.addEventListener('change', () => {
                this.checkField($element);
            });

            if ($field.type === 'radio') {
                const name = $field.getAttribute('name');
                const $form = $element.closest('form');

                if ($form) {
                    $form.addEventListener('change', (e) => {
                        if (e.target.name === name) {
                            this.checkField($element);
                        }
                    });
                }
            }

            $field.addEventListener('focus', () => {
                $element.classList.remove(this.settings.errorClassname);
            });

            $field.addEventListener('invalid', () => {
                $element.classList.add(this.settings.errorClassname);
            });
        }
    }

    checkField ($element) {
        const formType = $element.getAttribute(this.settings.initAttr);

        switch (formType) {
        case 'select':
        case 'multiselect': {
            const $field = $element.querySelector('select');
            let filled = true;

            if ($field) {
                if ($field.value === '') {
                    filled = false;
                }

                if ($field.value === 0 || $field.value === '0') {
                    const $emptyOption = $field.querySelector('option[value="0"]');

                    if ($emptyOption && $emptyOption.innerText === '') {
                        filled = false;
                    }
                }

                if (filled === false) {
                    $element.classList.remove(this.settings.filledClassname);
                } else {
                    $element.classList.add(this.settings.filledClassname);
                }
            }

            break;
        }
        case 'radio':
        case 'checkbox': {
            const $field = $element.querySelector('input');

            if ($field) {
                if ($field.checked) {
                    $element.classList.add(this.settings.filledClassname);
                } else {
                    $element.classList.remove(this.settings.filledClassname);
                }
            }

            break;
        }
        case 'date': {
            const $field = $element.querySelector('input');

            if ($field) {
                if ($field.getAttribute('data-form-enddate')) {
                    const $enddate = document.querySelector($field.getAttribute('data-form-enddate'));
                    if ($enddate && $field.value !== '') {
                        $enddate.setAttribute('min', $field.value);
                    }
                }

                if ($field.value !== '') {
                    $element.classList.add(this.settings.filledClassname);
                } else {
                    $element.classList.remove(this.settings.filledClassname);
                }
            }

            break;
        }
        default: {
            const $field = $element.querySelector('input, textarea');

            if ($field) {
                if ($field.value !== '') {
                    $element.classList.add(this.settings.filledClassname);
                } else {
                    $element.classList.remove(this.settings.filledClassname);
                }
            }
        }
        }
    }
}

export { FormField };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$formField = $context.querySelectorAll('[data-formfield]');
        for (let i = 0; i < $$formField.length; i++) {
            const $formField = $$formField[i];

            const formFieldAPI = new FormField($formField);
            $formField.API = formFieldAPI;
        }
    }
});
